import { AnalyticsParams } from "../analyticsClient";
import { compactAnalyticsParams } from "./common";
import { ReaderNavigationContext } from "../../screens/reader/types";
import { mapDetailSourceFromNavigation } from "./source";

export type ComicDetailViewParamsInput = {
  comicId: number;
  source: string;
  impressionId?: string;
  searchQueryId?: string;
  searchResultPosition?: number;
  referrerUrl?: string;
};

export type ReleaseDetailViewParamsInput = {
  comicId: number;
  releaseId: number;
  source: string;
  impressionId?: string;
  searchQueryId?: string;
  searchResultPosition?: number;
  referrerUrl?: string;
};

export function buildComicDetailViewParams(
  input: ComicDetailViewParamsInput,
): AnalyticsParams {
  const searchAttribution =
    input.source === "search"
      ? {
          search_query_id: input.searchQueryId,
          search_result_position: input.searchResultPosition,
        }
      : {};

  return compactAnalyticsParams({
    comic_id: input.comicId,
    source: input.source,
    impression_id: input.impressionId,
    ...searchAttribution,
    referrer_url: input.referrerUrl,
  });
}

export function buildReleaseDetailViewParams(
  input: ReleaseDetailViewParamsInput,
): AnalyticsParams {
  const searchAttribution =
    input.source === "search"
      ? {
          search_query_id: input.searchQueryId,
          search_result_position: input.searchResultPosition,
        }
      : {};

  return compactAnalyticsParams({
    comic_id: input.comicId,
    release_id: input.releaseId,
    source: input.source,
    impression_id: input.impressionId,
    ...searchAttribution,
    referrer_url: input.referrerUrl,
  });
}

export function mapDetailSource(
  navigationContext?: ReaderNavigationContext,
): string {
  return mapDetailSourceFromNavigation(navigationContext);
}
